import { PageScaffold } from "../../shared/ui/PageScaffold";

const adminLinks = [
  { to: "/t/:tenantSlug/teacher/admin", label: "管理ホーム" },
  { to: "/t/:tenantSlug/teacher/admin/guardian-links", label: "保護者紐付け" }
];

export function AdminMembersPage() {
  return (
    <PageScaffold
      title="Admin Members"
      description="member 一覧画面のプレースホルダーです。"
      links={adminLinks}
    >
      <p>ここに tenant member 一覧を表示します。</p>
    </PageScaffold>
  );
}
